module.exports = "/packs/course-webdesign-aad99ff01caccf012a15921314ea5805.png";